import { useRef } from 'react';
import { useTheme } from '@material-ui/core/styles';

export default () => {
  const theme = useTheme();
  const ref = useRef<HTMLElement>();

  function scrollTo() {
    const refOffset = ref?.current?.offsetTop ?? 0;
    const totalOffset = theme.custom.sidebarOffset;

    window.scrollTo(0, refOffset - totalOffset);
  }

  return {
    ref,
    scrollTo,
  };
};
